import React from 'react'
import { connect } from "react-redux";
import { Icon } from "semantic-ui-react";
import { Menu, Popup } from 'semantic-ui-react'
import { updateEntity } from "../../actions/entities";
import { postJson } from "../../api_helpers";

class PeppolItem extends  React.Component {
  render() {
    const { invoice } = this.props
    let message = invoice.sendPeppolWarning

    if (invoice.proposed || invoice.concept || message === 'not_an_organisation') {return <span></span>}

    let Icon, header, action
    let sendAction = () => this.props.send(invoice)

    if (!message) {Icon = this.baseIcon(false), action = sendAction, header = I18n.t('components.peppol_item.send')}
    else if (message === "sending") {Icon = this.baseIcon(true), action = null, header = I18n.t('components.peppol_item.error.sending')}
    else if (message === "sent") {Icon = this.succesIcon(), action = null, header = I18n.t('components.peppol_item.error.sent')}
    else if (message === "not_configured" || message ==="no_enterprise_number" || message==="no_country_code") {
      Icon = this.baseIcon(false), action = null, header = I18n.t(`components.peppol_item.error.${message}`)
    }
    else {Icon = this.errorIcon(), action = sendAction, header = I18n.t(`components.peppol_item.error.${message}`)}

    return <Popup trigger={<Menu.Item disabled={!action} onClick={action}>{Icon} </Menu.Item>} header={header}/>
  }

  baseIcon(spinning) {
    return <Icon loading={spinning} size='large' name="react"/>
  }

  succesIcon() {
    return (<Icon.Group size="large">
      <Icon name="react"/>
      <Icon corner name="check circle" color="green"/>
    </Icon.Group>)
  }

  errorIcon() {
    return (<Icon.Group size="large">
      <Icon name="react"/>
      <Icon corner name="times circle" color="red"/>
    </Icon.Group>)
  }

}

const mapDispatchToProps = (dispatch) => {
  return {
    send: (invoice) => {
      dispatch(updateEntity('invoice', { id: invoice.id, sendPeppolWarning: "sending"}))
      postJson(Routes.send_on_peppol_api_invoice_path({ id: invoice.id, _options: true }))
    },
  };
}

export default connect(null, mapDispatchToProps)(PeppolItem);
